import $ from 'jquery'

export const init = async function () {

    $(document).on('click', 'div[data-testid="form-row"]:nth-last-child(2).kl-private-reset-css-Xuajs1 label.kl-private-reset-css-Xuajs1 div.kl-private-reset-css-Xuajs1', function () {
      window.open("/pages/veganuary-t-c", '_blank');
    });

}
